import { useRef, useState } from "react";
import PlaceholderImage from "./PlaceholderImage";
import "./TransformationCard.css";

export default function TransformationCard({ transformation }) {
  const [pos, setPos] = useState(50);
  const trackRef = useRef(null);

  const updateFromClientX = (clientX) => {
    const rect = trackRef.current.getBoundingClientRect();
    const percent = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(100, Math.max(0, percent)));
  };

  const handlePointerDown = (e) => {
    e.target.setPointerCapture?.(e.pointerId);
    updateFromClientX(e.clientX);
  };
  const handlePointerMove = (e) => {
    if (e.buttons !== 1 && e.pointerType !== "touch") return;
    updateFromClientX(e.clientX);
  };

  return (
    <div className="transformation-card">
      <div
        className="transformation-card__track"
        ref={trackRef}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
      >
        <div className="transformation-card__before">
          <PlaceholderImage tone="2" alt={`${transformation.name} before transformation`} ratio="16/10" />
          <span className="transformation-card__label transformation-card__label--before">Before</span>
        </div>
        <div className="transformation-card__after" style={{ width: `${pos}%` }}>
          <PlaceholderImage tone="4" alt={`${transformation.name} after transformation`} ratio="16/10" />
          <span className="transformation-card__label transformation-card__label--after">After</span>
        </div>
        <div className="transformation-card__handle" style={{ left: `${pos}%` }} aria-hidden="true">
          <span>↔</span>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          className="transformation-card__slider"
          aria-label="Drag to compare before and after images"
        />
      </div>
      <div className="transformation-card__info">
        <h3>{transformation.name}</h3>
        <p className="transformation-card__duration">{transformation.duration}</p>
        <p className="transformation-card__details">{transformation.details}</p>
        <p className="transformation-card__disclaimer">{transformation.disclaimer}</p>
      </div>
    </div>
  );
}
